import { type AuthState } from '@okta/okta-auth-js';

export const getUserInitials = (authState: AuthState | null): string => {
  const claims = authState?.idToken?.claims;
  if (!claims) return '';

  const firstNameInitial = (claims.firstName as string)?.[0] || ' ';
  const lastNameInitial = (claims.lastName as string)?.[0] || ' ';
  const emailInitial = claims.email
    ?.split('@')[0]
    .split('.')
    .map((part) => part[0])
    .join('');

  const initials = `${firstNameInitial}${lastNameInitial}`.trim() || emailInitial;
  return initials?.toUpperCase() ?? '';
};
